import { styled } from "@octopus-energy/coral-design/jsx"
import { token } from "@octopus-energy/coral-design/tokens"

export const StyledCover = styled("div", {
    base: {
        position: "relative",
        marginBottom: 0,
        md: {
            marginBottom: "calc(-100vw / (1440 / 120))",
        },
    },
})

export const StyledGradient = styled("div", {
    base: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        bgLinear: "to-b",
        gradientFrom: "transparent 5%",
        gradientTo: `${token("colors.background.base.900")} 50%`,
        height: "calc(100vw / (1440 / 284))",
        md: {
            bgLinear: "to-b",
            gradientFrom: "transparent",
            gradientTo: `${token("colors.background.base.900")} 50%`,
        },
    },
})
